import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    type: 'kor',
    exhibitionRoom: {
        id: null,
        seq: null,
        imageAltText: "",
        name: "",
        introduction: "",
        roomNo: "",
        invalid: true,
        language: { id: 1 },
        parentId: null,
        imageUrl: null,
        commentator: { id : null },
        commentatorForKid: { id : null },
        commentatorForBlind: { id : null },
    },
    subTopic: {
        id: "",
        seq: "",
        title: "",
    },
    exhibitionImageFile: null,
    previewImage: null,
    subTopicList: [],
    commentatorList: [],
    subCommentator: '',
    subCommentatorForKid: '',
    subCommentatorForBlind: '',
    panelValue: 0,
}

const exhibition = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setType(state, action) {
            state.type = action.payload;
        },
        setPanelValue(state, action) {
            state.panelValue = action.payload;
        },
        setLanguageId(state, action) {
            state.exhibitionRoom.languageId = state.type === "kor" ? 1 : 2;
        },
        setExhibitionRoom(state, action) {
            state.exhibitionRoom = action.payload;
        },
        setSubTopic(state, action) {
            state.subTopic = action.payload;
        },
        setSubTopicList(state, action) {
            state.subTopicList = action.payload;
        },
        setFile(state, action) {
            state.exhibitionImageFile = action.payload;
        },
        setPreviewImage(state, action) {
            state.previewImage = action.payload;
        },
        setCommentatorList(state, action) {
            state.commentatorList = action.payload;
        },
        setExhibitionImageFile(state, action) {
            state.exhibitionImageFile = action.payload;
        },
        setSubCommentator(state, action) {
            state.subCommentator = action.payload;
        },
        setSubCommentatorForKid(state, action) {
            state.subCommentatorForKid = action.payload;
        },
        setSubCommentatorForBlind(state, action) {
            state.subCommentatorForBlind = action.payload;
        },
    }
})

export const exhibitionActions = exhibition.actions;
export default exhibition;